import { useEffect, useState } from 'react';
import { useAppContext } from '../hooks';
import { AppContext } from './AppContext';

const PageViewer = () => {
    const appContext = useAppContext();
    const { RootDocument } = appContext;

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <AppContext.Provider value={{ ...appContext, isClient }}>
            <RootDocument />
        </AppContext.Provider>
    );
};

export default PageViewer;
